import PropTypes from 'prop-types';
import React from 'react';
import { MODULE_TYPE_BACKGROUND_COLORS } from 'src/constants/m-line';

const ModuleTypeDot = ({ containerType }) => {
  const backgroundColorClass = MODULE_TYPE_BACKGROUND_COLORS[containerType] || 'default-bg-color';

  return (
    <div className={`transaction-module-dot ${backgroundColorClass}`}>
      <span className='transaction-module-dot-text'>
        {containerType.slice(0, 1).toUpperCase()}
      </span>
    </div>
  );
};

ModuleTypeDot.propTypes = {
  containerType: PropTypes.string.isRequired,
};

export default ModuleTypeDot;
